<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("ventasPorClientes")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">

                        <div class="col-md-3">
                            <div class="form-group">
                                <label>{{$t("companya")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idCompany"
                                           filterable
                                           @change="idsClients = []; getBusiness()"
                                           :placeholder="$t('seleccionaCompania')">
                                    <el-option v-for="c in listCompany"
                                               class="select-primary"
                                               :value="c.id"
                                               :label="c.name"
                                               :key="c.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change="getSalesProducts()">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="$t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="$t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>&nbsp;</label>
                                <button class="btn btn-primary" @click="getSalesProducts()" style="width: 100%" :disabled="loading">
                                    <img src="static/img/sync.gif" alt="" v-if="loading" width="15">
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="filtro-clientes">
                                <label class="filtro-clientes__label">{{$t("clientes")}}</label>

                                <div class="filtro-clientes__barra">
                                    <el-popover v-model="popoverClientes"
                                                placement="bottom-start"
                                                width="380"
                                                trigger="click"
                                                popper-class="popover-clientes"
                                                @show="busquedaCliente = ''">

                                        <div class="popover-clientes__cabecera">
                                            <el-input v-model="busquedaCliente"
                                                      size="small"
                                                      clearable
                                                      prefix-icon="el-icon-search"
                                                      :placeholder="$t('buscarCliente')">
                                            </el-input>
                                            <div class="popover-clientes__acciones">
                                                <span class="text-muted">
                                                    {{ clientesFiltrados.length }} {{ $t('clientesConVentasEnElPeriodo') }}
                                                </span>
                                                <span>
                                                    <a href="#" @click.prevent="seleccionarClientesVisibles()">{{ $t('seleccionarTodos') }}</a>
                                                    &middot;
                                                    <a href="#" @click.prevent="quitarFiltroClientes()">{{ $t('limpiar') }}</a>
                                                </span>
                                            </div>
                                        </div>

                                        <div class="popover-clientes__lista">
                                            <label v-for="c in clientesFiltrados"
                                                   :key="c.id"
                                                   class="popover-clientes__item"
                                                   :class="{ 'is-activo': idsClients.includes(c.id) }">
                                                <input type="checkbox" :value="c.id" v-model="idsClients">
                                                <span class="popover-clientes__nombre">
                                                    {{ nombreCliente(c) }}
                                                    <span v-if="c.clientActive == 0" class="badge badge-danger ml-1">{{ $t("BAJA") }}</span>
                                                </span>
                                                <span class="popover-clientes__meta">
                                                    {{ c.units }} {{ $t('tickets').toLowerCase() }} &middot; {{ c.amount | currency }}
                                                </span>
                                            </label>
                                            <div v-if="clientesFiltrados.length === 0" class="popover-clientes__vacio">
                                                {{ listaCompleta.length === 0 ? $t('noHayClientesConVentas') : $t('ningunClienteCoincide') }}
                                            </div>
                                        </div>

                                        <div class="popover-clientes__pie">
                                            <span class="text-muted">{{ idsClients.length }} {{ $t('seleccionados') }}</span>
                                            <button class="btn btn-primary btn-sm" @click="popoverClientes = false">{{ $t('aceptar') }}</button>
                                        </div>

                                        <button slot="reference" type="button" class="filtro-clientes__boton" :class="{ 'is-activo': idsClients.length > 0 }">
                                            <i class="fa fa-users"></i>
                                            <span>{{ resumenFiltroClientes }}</span>
                                            <i class="fa fa-chevron-down filtro-clientes__chevron"></i>
                                        </button>
                                    </el-popover>

                                    <span v-for="c in clientesSeleccionados"
                                          :key="'tag-' + c.id"
                                          class="filtro-clientes__tag">
                                        <span class="filtro-clientes__tag-nombre">{{ nombreCliente(c) }}</span>
                                        <button type="button"
                                                class="filtro-clientes__tag-quitar"
                                                :title="$t('quitarFiltro')"
                                                @click="quitarCliente(c.id)">
                                            <i class="fa fa-times"></i>
                                        </button>
                                    </span>

                                    <a v-if="idsClients.length > 0" href="#" class="filtro-clientes__quitar" @click.prevent="quitarFiltroClientes()">
                                        <i class="fa fa-times"></i> {{ $t('quitarFiltro') }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <div class="col-md-12" v-else-if="respuesta">
                <template v-if="list.length>0">
                    <div v-if="idsClients.length > 0" class="aviso-filtro-clientes">
                        <i class="fa fa-filter"></i>
                        {{ $t('mostrando') }} <strong>{{ list.length }}</strong> {{ $t('deLosClientes', { total: listaCompleta.length }) }}
                        &middot; <a href="#" @click.prevent="quitarFiltroClientes()">{{ $t('verTodos') }}</a>
                    </div>
                    <div class="row justify-content-between div-export">

                        <div class="col-md-2 col-xs-12">
                            <el-dropdown>
                                <el-button type="primary" size="small">
                                    <i class="fa fa-file"></i>
                                    {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <a :href="urlExportPDF">
                                        <el-dropdown-item class="text-danger">
                                            <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                    <a :href="urlExportExcel">
                                        <el-dropdown-item class="text-success">
                                            <strong>
                                                <i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                </el-dropdown-menu>
                            </el-dropdown>

                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-bordered table-striped text-nowrap">
                            <thead class="thead-dark">
                            <tr>
                                <th v-if="ordenarCliente===0" @click="sortedArrayNameASC('name')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t("cliente")}}
                                </th>
                                <th v-else @click="sortedArrayNameDESC('name')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("cliente")}}
                                </th>

                                <th v-if="ordenarImporte===0" @click="sortedArrayImporteASC('amount')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t("importe")}}
                                </th>
                                <th v-else @click="sortedArrayImporteDESC('amount')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("importe")}}
                                </th>
                                <th v-if="ordenarImporteIva===0" @click="sortedArrayImporteIvaASC('amount')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t("importe")}} sin IVA
                                </th>
                                <th v-else @click="sortedArrayImporteIvaDESC('amount')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("importe")}} sin IVA
                                </th>
                                <th v-if="ordenarConsumiciones===0" @click="sortedArrayConsumicionesASC('units')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t('tickets')}}
                                </th>
                                <th v-else @click="sortedArrayConsumicionesDESC('units')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t('tickets')}}
                                </th>
                                <th @click="ordenarPorCampo('consumiciones')"><i
                                        style="color: white" :class="claseOrden('consumiciones')"></i> {{$t('consumiciones')}}
                                </th>
                                <th v-if="ordenarComensales===0" @click="sortedArrayComensalesASC('units')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t('comensales')}}
                                </th>
                                <th v-else @click="sortedArrayComensalesDESC('units')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t('comensales')}}
                                </th>

                                <th v-if="ordenarMedio===0" @click="sortedArrayMedioASC('amount/units')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t("valorMedioDelTicket")}}
                                </th>

                                <th v-else @click="sortedArrayMedioDESC('amount/units')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("valorMedioDelTicket")}}
                                </th>

                                <th @click="ordenarPorCampo('discount')"><i
                                        style="color: white" :class="claseOrden('discount')"></i> {{$t("descuento")}}
                                </th>

                                <th v-if="ordenarImporteTotal===0" @click="sortedArrayImporteTotalASC('totalAmount')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t("importeSinDescuento")}}
                                </th>

                                <th v-else @click="sortedArrayImporteTotalDESC('totalAmount')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("importeSinDescuento")}}
                                </th>

                                <th v-if="ordenarImporteTotalIva===0" @click="sortedArrayImporteTotalIvaASC('totalAmountWithoutIVA')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t("importeSinDescuento")}} sin IVA 
                                </th>

                                <th v-else @click="sortedArrayImporteTotalIvaDESC('totalAmountWithoutIVA')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("importeSinDescuento")}} sin IVA 
                                </th>

                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="obj in list">
                                <td>
                                    {{obj.name +' ' +obj.surName}}
                                    <span style="color: red" v-if="obj.clientActive == 0">[{{ $t("BAJA") }}]</span>
                                </td>
                                <td align="right">{{obj.amount | currency}}</td>
                                <td align="right">{{obj.amountWithoutIVA | currency}}</td>
                                <td align="right">{{obj.units}}</td>
                                <td align="right">{{formatCantidad(obj.consumiciones)}}</td>
                                <td align="right">{{obj.comensales}}</td>
                                <td align="right">{{obj.amount / obj.units | currency}}</td>
                                <td align="right">{{obj.discount | currency}}</td>
                                <td align="right">{{obj.totalAmount | currency}}</td>
                                <td align="right">{{obj.totalAmountWithoutIVA | currency}}</td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr class="table-success">
                                <td><strong>{{$t("total")}}</strong></td>
                                <td class="text-right"><strong>{{getTotalPrecio | currency}}</strong></td>
                                <td class="text-right"><strong>{{getTotalPrecioSinIVA | currency}}</strong></td>
                                <td class="text-right"><strong>{{getTotalConsumiciones}}</strong></td>
                                <td class="text-right"><strong>{{formatCantidad(getTotalProductosConsumidos)}}</strong></td>
                                <td class="text-right"><strong>{{getTotalComensales}}</strong></td>
                                <td class="text-right"><strong>{{getTotalPrecio/getTotalConsumiciones | currency}}</strong></td>
                                <td class="text-right"><strong>{{getTotalDescuento | currency}}</strong></td>
                                <td class="text-right"><strong>{{getTotalPrecioCompleto | currency}}</strong></td>
                                <td class="text-right"><strong>{{getTotalPrecioCompletoSinIVA | currency}}</strong></td>

                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </template>
                <template v-else>
                    <div class="alert alert-danger" role="alert">
                        {{$t("noHay")}} <strong>{{$t("ventasPorClientes")}}</strong> {{$t("rangoDeFechas")}}
                    </div>
                </template>
            </div>

        </div>
    </div>

</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    import Chart from 'chart.js';
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, Popover, Input} from 'element-ui'
    import moment from 'moment'
    import { mapState } from 'vuex'

    export default {
        created() {
            this.$store.dispatch("setNameRoute", this.$i18n.t("ventasPorClientes"));
            this.getCompanies();

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;
            }

        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Popover.name]: Popover,
            [Input.name]: Input
        },
        data() {
            return {
                loading: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                listBusinesses: [],
                idBusiness: 0,
                mode: 0,
                contador: 0,
                chartIn: 0,
                listCompany: [],
                idCompany: 0,
                idsClients: [],
                listaCompleta: [],
                popoverClientes: false,
                busquedaCliente: '',
                ordenCampo: '',
                ordenAsc: true,

                ordenarInvitations: 0,
                ordenarConsumiciones: 0,
                ordenarComensales: 0,
                ordenarImporte: 0,
                ordenarImporteIva: 0,
                ordenarCliente: 0,
                ordenarMedio: 0,
                ordenarImporteTotal: 0,
                ordenarImporteTotalIva: 0,
                

                respuesta: true,
            }
        },
        computed: {
            ...mapState(["permiso"]),
            // La tabla muestra todos los clientes con ventas o solo los elegidos en el filtro
            list() {
                if (this.idsClients.length === 0) {
                    return this.listaCompleta;
                }
                return this.listaCompleta.filter(c => this.idsClients.includes(c.id));
            },
            clientesOrdenados() {
                return this.listaCompleta.slice().sort((a, b) => this.nombreCliente(a).localeCompare(this.nombreCliente(b)));
            },
            clientesFiltrados() {
                const q = this.normalizar(this.busquedaCliente);
                if (!q) {
                    return this.clientesOrdenados;
                }
                return this.clientesOrdenados.filter(c =>
                    this.normalizar(this.nombreCliente(c) + ' ' + (c.barCode || '') + ' ' + (c.cifNif || '') + ' ' + (c.phone || '')).includes(q));
            },
            clientesSeleccionados() {
                return this.clientesOrdenados.filter(c => this.idsClients.includes(c.id));
            },
            resumenFiltroClientes() {
                if (this.idsClients.length === 0) {
                    return this.$t('todosLosClientes');
                }
                if (this.idsClients.length === 1 && this.clientesSeleccionados.length === 1) {
                    return this.nombreCliente(this.clientesSeleccionados[0]);
                }
                return this.idsClients.length + ' ' + this.$t('clientesSeleccionados');
            },
            urlExportPDF() {
                // return "../api/public/index.php/clients/exportSalesByClients/PDF?idBusiness=" + this.idBusiness + "&idCompany=" + this.idCompany + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
   
                return this.$store.getters.apiUrl+"/clients/exportSalesByClients/PDF?idBusiness=" + this.idBusiness + "&idCompany=" + this.idCompany + "&idsClients=" + this.idsClients.join(",") + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },
            urlExportExcel() {
                // return "../api/public/index.php/clients/exportSalesByClients/Excel?idBusiness=" + this.idBusiness + "&idCompany=" + this.idCompany + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
 
                return this.$store.getters.apiUrl+"/clients/exportSalesByClients/Excel?idBusiness=" + this.idBusiness + "&idCompany=" + this.idCompany + "&idsClients=" + this.idsClients.join(",") + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },

            getTotalPrecio() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.amount;
                });
                return total;
            },
            getTotalPrecioSinIVA() {
                let total = 0;
                this.list.forEach(function (d) {
                    total += d.amountWithoutIVA;
                })
                return total;
            },
            getTotalPrecioCompleto() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.totalAmount;
                });
                return total;
            },
            getTotalPrecioCompletoSinIVA() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.totalAmountWithoutIVA;
                });
                return total;
            },
            getTotalConsumiciones() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.units;
                });
                return total;
            },
            getTotalProductosConsumidos() {
                return this.list.reduce((total, d) => total + (parseFloat(d.consumiciones) || 0), 0);
            },
            getTotalDescuento() {
                return this.list.reduce((total, d) => total + (parseFloat(d.discount) || 0), 0);
            },
            getTotalComensales() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += parseInt(d.comensales);
                });
                return total;
            },

            getTotalMedia() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.amount / d.units;
                });
                return total;
            }
        },
        methods: {
            formatCantidad(valor) {
                const numero = parseFloat(valor) || 0;
                return Number.isInteger(numero) ? numero : numero.toLocaleString('es-ES', {maximumFractionDigits: 3});
            },
            claseOrden(campo) {
                if (this.ordenCampo !== campo) {
                    return 'fa fa-angle-up';
                }
                return this.ordenAsc ? 'fa fa-angle-down' : 'fa fa-angle-up';
            },
            ordenarPorCampo(campo) {
                this.ordenAsc = this.ordenCampo === campo ? !this.ordenAsc : true;
                this.ordenCampo = campo;
                const signo = this.ordenAsc ? 1 : -1;
                this.listaCompleta.sort((a, b) => ((parseFloat(a[campo]) || 0) - (parseFloat(b[campo]) || 0)) * signo);
            },
            nombreCliente(c) {
                return ((c.name || '') + ' ' + (c.surName || '')).trim();
            },
            normalizar(texto) {
                return (texto || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
            },
            seleccionarClientesVisibles() {
                const ids = new Set(this.idsClients);
                this.clientesFiltrados.forEach(c => ids.add(c.id));
                this.idsClients = Array.from(ids);
            },
            quitarCliente(id) {
                this.idsClients = this.idsClients.filter(x => x !== id);
            },
            quitarFiltroClientes() {
                this.idsClients = [];
            },


            sortedArrayNameASC: function () {
                this.ordenarCliente = 1;

                function compare(a, b) {
                    if (a.name.toUpperCase() < b.name.toUpperCase())
                        return -1;
                    if (a.name.toUpperCase() > b.name.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.listaCompleta.sort(compare);
            },
            sortedArrayNameDESC: function () {
                this.ordenarCliente = 0;

                function compare(a, b) {

                    if (a.name.toUpperCase() > b.name.toUpperCase())
                        return -1;
                    if (a.name.toUpperCase() < b.name.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.listaCompleta.sort(compare);
            },
            sortedArrayImporteASC: function () {
                this.ordenarImporte = 1;

                function compare(a, b) {
                    if (a.amount < b.amount)
                        return -1;
                    if (a.amount > b.amount)
                        return 1;
                    return 0;
                }

                return this.listaCompleta.sort(compare);
            },
            sortedArrayImporteDESC: function () {
                this.ordenarImporte = 0;

                function compare(a, b) {

                    if (a.amount > b.amount)
                        return -1;
                    if (a.amount < b.amount)
                        return 1;
                    return 0;
                }

                return this.listaCompleta.sort(compare);
            },
            sortedArrayImporteTotalASC: function () {
                this.ordenarImporteTotal = 1;

                function compare(a, b) {
                    if (a.totalAmount < b.totalAmount)
                        return -1;
                    if (a.totalAmount > b.totalAmount)
                        return 1;
                    return 0;
                }

                return this.listaCompleta.sort(compare);
            },
            sortedArrayImporteTotalDESC: function () {
                this.ordenarImporteTotal = 0;

                function compare(a, b) {

                    if (a.totalAmount > b.totalAmount)
                        return -1;
                    if (a.totalAmount < b.totalAmount)
                        return 1;
                    return 0;
                }

                return this.listaCompleta.sort(compare);
            },
            sortedArrayImporteIvaASC: function () {
                this.ordenarImporteIva = 1;

                function compare(a, b) {
                    if (a.amountWithoutIVA < b.amountWithoutIVA)
                        return -1;
                    if (a.amountWithoutIVA > b.amountWithoutIVA)
                        return 1;
                    return 0;
                }

                return this.listaCompleta.sort(compare);
            },
            sortedArrayImporteIvaDESC: function () {
                this.ordenarImporteIva = 0;

                function compare(a, b) {

                    if (a.amountWithoutIVA > b.amountWithoutIVA)
                        return -1;
                    if (a.amountWithoutIVA < b.amountWithoutIVA)
                        return 1;
                    return 0;
                }

                return this.listaCompleta.sort(compare);
            },
            sortedArrayImporteTotalIvaASC: function () {
                this.ordenarImporteTotalIva = 1;

                function compare(a, b) {
                    if (a.totalAmountWithoutIVA < b.totalAmountWithoutIVA)
                        return -1;
                    if (a.totalAmountWithoutIVA > b.totalAmountWithoutIVA)
                        return 1;
                    return 0;
                }

                return this.listaCompleta.sort(compare);
            },
            sortedArrayImporteTotalIvaDESC: function () {
                this.ordenarImporteTotalIva = 0;

                function compare(a, b) {

                    if (a.totalAmountWithoutIVA > b.totalAmountWithoutIVA)
                        return -1;
                    if (a.totalAmountWithoutIVA < b.totalAmountWithoutIVA)
                        return 1;
                    return 0;
                }

                return this.listaCompleta.sort(compare);
            },
            sortedArrayConsumicionesASC: function () {
                this.ordenarConsumiciones = 1;

                function compare(a, b) {
                    if (a.units < b.units)
                        return -1;
                    if (a.units > b.units)
                        return 1;
                    return 0;
                }

                return this.listaCompleta.sort(compare);
            },
            sortedArrayConsumicionesDESC: function () {
                this.ordenarConsumiciones = 0;

                function compare(a, b) {

                    if (a.units > b.units)
                        return -1;
                    if (a.units < b.units)
                        return 1;
                    return 0;
                }

                return this.listaCompleta.sort(compare);
            },
            sortedArrayComensalesASC: function () {
                this.ordenarComensales = 1;

                function compare(a, b) {
                    if (a.comensales < b.comensales)
                        return -1;
                    if (a.comensales > b.comensales)
                        return 1;
                    return 0;
                }

                return this.listaCompleta.sort(compare);
            },
            sortedArrayComensalesDESC: function () {
                this.ordenarComensales = 0;

                function compare(a, b) {

                    if (a.comensales > b.comensales)
                        return -1;
                    if (a.comensales < b.comensales)
                        return 1;
                    return 0;
                }

                return this.listaCompleta.sort(compare);
            },
            sortedArrayMedioASC: function () {
                this.ordenarMedio = 1;

                function compare(a, b) {
                    if (a.amount / a.units < b.amount / b.units)
                        return -1;
                    if (a.amount / a.units > b.amount / b.units)
                        return 1;
                    return 0;
                }

                return this.listaCompleta.sort(compare);
            },
            sortedArrayMedioDESC: function () {
                this.ordenarMedio = 0;

                function compare(a, b) {

                    if (a.amount / a.units > b.amount / b.units)
                        return -1;
                    if (a.amount / a.units < b.amount / b.units)
                        return 1;
                    return 0;
                }

                return this.listaCompleta.sort(compare);
            },

            getCompanies() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getCompaniesByUser", config)
                    .then(function (response) {

                        if (!vm.idCompany) {
                            vm.idCompany = response.data.result[0].id;
                        }
                        vm.listCompany = response.data.result;

                        vm.getBusiness()

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getBusiness() {
                var config = {
                    params: {
                        idCompany: this.idCompany,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByCompany", config)
                    .then(function (response) {

                        vm.listBusinesses = [];

                        if (response.data.result.length > 0) {


                            let xDate = {

                                checked: false,
                                establishmentName: vm.$t('todos'),
                                id: 0
                            };
                            vm.listBusinesses.push(xDate);
                        }


                        for (let i = 0; i < response.data.result.length; i++) {

                            let xDate = {

                                checked: response.data.result[i].checked,
                                establishmentName: response.data.result[i].establishmentName,
                                id: response.data.result[i].id
                            };

                            vm.listBusinesses.push(xDate);

                        }

                        vm.getSalesProducts();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getSalesProducts() {

                if (this.datefrom === null || this.dateto === null) {
                    this.$notify({
                        message: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        icon: 'nc-icon nc-simple-remove',
                        timeout: 5000,
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'error'
                    });

                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        this.$notify({
                            message: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            icon: 'nc-icon nc-simple-remove',
                            timeout: 5000,
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'error'
                        });
                    } else {
                        this.loading = true;

                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                idCompany: this.idCompany,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.axios.get(this.$store.getters.apiUrl + "clients/getVentasByClients", config)
                            .then(function (response) {
                                if (response.data && response.data.response) {
                                    vm.listaCompleta = response.data.result;
                                    const conVentas = new Set(vm.listaCompleta.map(c => c.id));
                                    vm.idsClients = vm.idsClients.filter(id => conVentas.has(id));
                                    vm.respuesta = true;
                                } else if (response.data && response.data.response === false && response.data.rangoMayor === true) {
                                    vm.$notify({
                                        message: response.data.result,
                                        icon: 'nc-icon nc-alert-circle-i',
                                        timeout: 5000,
                                        horizontalAlign: 'right',
                                        verticalAlign: 'top',
                                        type: 'info'
                                    });
                                    vm.listaCompleta = [];
                                    vm.respuesta = false;
                                } else {
                                    vm.listaCompleta = [];
                                    vm.respuesta = false;
                                    vm.$notify({
                                        message: vm.$t('noSeHaPodidoConsultarIntenteloMasTarde'),
                                        icon: 'nc-icon nc-simple-remove',
                                        timeout: 5000,
                                        horizontalAlign: 'right',
                                        verticalAlign: 'top',
                                        type: 'error'
                                    });
                                }
                                vm.loading = false;

                            })
                            .catch(function (error) {
                                console.log(error);
                                vm.listaCompleta = [];
                                vm.respuesta = false;
                                vm.loading = false;
                                vm.$notify({
                                    message: vm.$t('noSeHaPodidoConsultarIntenteloMasTarde'),
                                    icon: 'nc-icon nc-simple-remove',
                                    timeout: 5000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'error'
                                });
                            });
                    }
                }
            }

        }
    }
</script>

<style scoped>


    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

    .filtro-clientes {
        margin-top: 6px;
        padding-top: 14px;
        border-top: 1px solid #eef0f4;
    }

    .filtro-clientes__barra {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
    }

    .filtro-clientes__boton {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        min-width: 240px;
        height: 40px;
        padding: 0 14px;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        color: #606266;
        font-size: 14px;
        cursor: pointer;
        transition: border-color .2s, box-shadow .2s;
    }

    .filtro-clientes__boton:hover,
    .filtro-clientes__boton:focus {
        border-color: #1E22AA;
        outline: none;
    }

    .filtro-clientes__boton.is-activo {
        border-color: #1E22AA;
        color: #1E22AA;
        background: #f4f5fc;
        font-weight: 600;
    }

    .filtro-clientes__chevron {
        margin-left: auto;
        font-size: 11px;
        opacity: .6;
    }

    .filtro-clientes__tag {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        max-width: 260px;
        height: 28px;
        padding: 0 8px 0 10px;
        background: #f4f5fc;
        border: 1px solid #d5d6f0;
        border-radius: 4px;
        color: #1E22AA;
        font-size: 12px;
        line-height: 1;
    }

    .filtro-clientes__tag-nombre {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .filtro-clientes__tag-quitar {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        padding: 0;
        margin: 0;
        border: none;
        background: transparent;
        box-shadow: none;
        color: inherit;
        font-size: 13px;
        line-height: 1;
        -webkit-text-stroke: .6px currentColor;
        cursor: pointer;
        transition: opacity .15s ease, transform .15s ease;
    }

    .filtro-clientes__tag-quitar:hover {
        opacity: .7;
        transform: scale(1.15);
    }

    .filtro-clientes__tag-quitar:focus {
        outline: none;
    }

    .filtro-clientes__quitar {
        font-size: 13px;
        color: #909399;
    }

    .filtro-clientes__quitar:hover {
        color: #F56C6C;
        text-decoration: none;
    }

    .aviso-filtro-clientes a {
        color: #1E22AA;
    }

    .aviso-filtro-clientes {
        margin-bottom: 10px;
        padding: 8px 12px;
        background: #f4f5fc;
        border-left: 3px solid #1E22AA;
        border-radius: 3px;
        color: #303133;
        font-size: 13px;
    }

    button:disabled {
        background-color: #999999 !important;
        border-color: #777777 !important;
        color: #ffffff !important;
        cursor: not-allowed !important;
        opacity: 0.7;
    }

    button:disabled:hover {
        background-color: #999999 !important;
        border-color: transparent !important;
    }

</style>

<style>
    /* El popover se pinta fuera del componente: estilos sin scoped, acotados por popper-class */
    .popover-clientes {
        padding: 0 !important;
    }

    .popover-clientes__cabecera {
        padding: 12px 12px 8px;
        border-bottom: 1px solid #eef0f4;
    }

    .popover-clientes__acciones {
        display: flex;
        justify-content: space-between;
        margin-top: 8px;
        font-size: 12px;
    }

    .popover-clientes__acciones a {
        color: #1E22AA;
    }

    .popover-clientes__lista {
        max-height: 300px;
        overflow-y: auto;
        padding: 4px 0;
    }

    .popover-clientes__item {
        display: flex;
        align-items: center;
        gap: 10px;
        margin: 0;
        padding: 7px 12px;
        cursor: pointer;
        font-weight: normal;
        text-transform: none;
        font-size: 13px;
        color: #303133;
    }

    .popover-clientes__item:hover {
        background: #f5f7fa;
    }

    .popover-clientes__item.is-activo {
        background: #f4f5fc;
    }

    .popover-clientes__item input {
        margin: 0;
        accent-color: #1E22AA;
    }

    .popover-clientes__nombre {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .popover-clientes__meta {
        color: #909399;
        font-size: 12px;
        white-space: nowrap;
    }

    .popover-clientes__vacio {
        padding: 18px 12px;
        text-align: center;
        color: #909399;
        font-size: 13px;
    }

    .popover-clientes__pie {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 12px;
        border-top: 1px solid #eef0f4;
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Clientes/VentasClientes.vue